// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_UL2","cls2":"DebugPage-cls2_Kka DebugPage-cls1_UL2"};